import { useEffect } from 'react';

export const unloadWarnListener = e => {
    // Cancel the event
    e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
    /* Modern browsers do not actually show the message here, but require
     * that this value be set to some value to show a standard warning.
     * Legacy browsers will actually show this text. We are using the standard
     * Chrome text here to provide a consistent experience.
     */
    const warningDefaultText = 'Changes you made may not be saved.';
    e.returnValue = warningDefaultText;
    return warningDefaultText;
};

export const removeUnloadListener = () => {
    window.removeEventListener('beforeunload', unloadWarnListener);
};

const useWarningOnUnload = () => {
    useEffect(() => {
        /* Cypress does not handle before unload well;
         * see https://github.com/cypress-io/cypress/issues/796
         */
        if (!window.Cypress) {
            window.addEventListener('beforeunload', unloadWarnListener);
            return removeUnloadListener;
        }
    }, []);
};

export default useWarningOnUnload;
